export default __webpack_public_path__ + "static/media/CustomCard.ffd75c6d.png";